<template>
  <div>
    <div v-if="mode === 'DESIGN'"  class="input-con max-width">
      <el-input size="small" class="disabled-box" :placeholder="placeholder"/>
      <span v-if="unit" class="unit">{{ unit }}</span>
      <div v-show="showChinese"  class="chinese-con">
        <span class="text">大写：</span>
        <span class="chinese">{{chinese}}</span>
      </div>

    </div>
    <template v-else>
      <div v-if="!readerMode  || perm==='E'" class="input-con input-con-number w-220">
        <el-input-number style="width: 100%;" :min="0" controls-position="right" :precision="precision" size="small" clearable v-model="_value" :disabled="perm==='R'" :placeholder="placeholder"/>
        <span v-if="unit" class="unit">{{ unit }}</span>
        <div v-show="showChinese"  class="chinese-con">
          <span  class="text">大写：</span>
          <span class="chinese">{{chinese}}</span>
        </div>
      </div>
      
      <div v-else class="form-item-text">
        {{ _value }}<template v-if="unit">{{unit}}</template>
        <span v-show="showChinese" class="chinese-con">
          <span class="chinese">（{{chinese}}）</span>
        </span>
      </div>
      <!-- <div  v-else  class="input-con input-con-number input-con-number-dis ">
        <el-input-number style="width: 100%;" :min="0" controls-position="right" :precision="precision" size="small" clearable v-model="_value" :placeholder="placeholder" disabled/>
        <el-input  v-model="_value" size="small" :placeholder="placeholder" type="number" disabled/>
        <span v-if="unit" class="unit">{{ unit }}</span>
        <div v-show="showChinese">
          <span>大写：</span>
          <span class="chinese">{{chinese}}</span>
        </div>
      </div> -->

    </template>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins'

export default {
  mixins: [componentMinxins],
  name: "AmountInput",
  components: {},
  props: {
    value: {
      default: null
    },
    placeholder: {
      type: String,
      default: '请输入金额'
    },
    showChinese: {
      type: Boolean,
      default: true
    },
    precision: {
      type: Number,
      default: 0
    },
    unit:{
      type: String,
      default: ''
    },
    readerMode: {
      type: Boolean,
      default: false
    },
  },
  computed:{
    chinese(){
      return this.convertCurrency(this.value)
    },
  },
  data() {
    return {}
  },
  methods: {
    convertCurrency(money) {
      //汉字的数字
      const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
      //基本单位
      const cnIntRadice = ['', '拾', '佰', '仟'];
      //对应整数部分扩展单位
      const cnIntUnits = ['', '万', '亿', '兆'];
      //对应小数部分单位
      const cnDecUnits = ['角', '分', '毫', '厘'];
      //整数金额时后面跟的字符
      const cnInteger = '整';
      //整型完以后的单位
      const cnIntLast = '元';
      //最大处理的数字
      let maxNum = 999999999999999.9999;
      //金额整数部分
      let integerNum;
      //金额小数部分
      let decimalNum;
      //输出的中文金额字符串
      let chineseStr = '';
      //分离金额后用的数组，预定义
      let parts;
      if (money === '') {
        return '';
      }
      money = parseFloat(money);
      if (money >= maxNum) {
        //超出最大处理数字
        return '';
      }
      if (money === 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr;
      }
      //转换为字符串
      money = money.toString();
      if (money.indexOf('.') === -1) {
        integerNum = money;
        decimalNum = '';
      } else {
        parts = money.split('.');
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, 4);
      }
      //获取整型部分转换
      if (parseInt(integerNum, 10) > 0) {
        var zeroCount = 0;
        var IntLen = integerNum.length;
        for (let i = 0; i < IntLen; i++) {
          let n = integerNum.substr(i, 1);
          let p = IntLen - i - 1;
          let q = p / 4;
          let m = p % 4;
          if (n == '0') {
            zeroCount++;
          } else {
            if (zeroCount > 0) {
              chineseStr += cnNums[0];
            }
            //归零
            zeroCount = 0;
            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if (m == 0 && zeroCount < 4) {
            chineseStr += cnIntUnits[q];
          }
        }
        chineseStr += cnIntLast;
      }
      //小数部分
      if (decimalNum !== '') {
        let decLen = decimalNum.length;
        for (let i = 0; i < decLen; i++) {
          let n = decimalNum.substr(i, 1);
          if (n !== '0') {
            chineseStr += cnNums[Number(n)] + cnDecUnits[i];
          }
        }
      }
      if (chineseStr === '') {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
      } else if (decimalNum === '') {
        chineseStr += cnInteger;
      }
      return chineseStr;
    }
  }
}
</script>

<style lang="scss" scoped>
.max-width{
  max-width: 208px;
}
.w-220{
    // width: 220px;
    width: 100%;
    max-width: 220px;
}
.chinese{
  color: #afadad;
  font-size: 14px;
}
 /deep/ .el-input__inner{
   text-align: left;
 }
 .input-con {
  position: relative;
  .unit {
    position: absolute;
    right: 8px;
    top: 0;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    color: #c5c9c9;
  }
}
 .input-con-number{
  line-height: 1;
  margin-top: 6px;
  /deep/.el-input-number .el-input__inner{
    text-align: left;
  }
  .unit{
    right: 45px;
    // line-height: 44px;
    // height: 44px;
  }
}
.input-con-number-dis{
  .unit{
    right: 8px;
  }
}
.chinese-con{
  padding-top: 6px;
  line-height: 1;
  // color: #2F3030;
  .text{
    color: #939696;
  }
  .chinese{
    color: #2F3030;
  }
}
</style>
